import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    cancelButtonLabel: 'Cancel',
    changePasswordTitle: 'Change Password',
    currentPasswordLabel: 'Current Password',
    newPasswordLabel: 'New Password',
    note: 'Note: once you have changed your password you will be logged out.',
    passwordLabel: 'Password',
    requiredValidation: 'This field is required',
    submitButtonLabel: 'Submit New Password',
  },
})
